import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SurveyForm  from "./form/SurveyForm.tsx";
import { UseAPICaller } from "../apiCaller.tsx";


const SurveyPage = () => {
    const {id} = useParams<{id:string}>();
    const [survey, setSurvey] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [notActive, setNotActive] = useState(false);

    const {GetSurvey} = UseAPICaller();

    useEffect(() => {
        const fetchSurvey = async () => {
        try {
            let data = await GetSurvey(parseInt(id));

            if (!data.active) {
                console.log(data.active);
                setNotActive(true);
            } 
            else 
            {
                //Array.from({ length: q.scale }, (_, i) => i + 1)
                // choices: [
                //     { value: 1, text: "Strongly disagree" },
                //     { value: 2, text: "Disagree" },
                //     { value: 3, text: "Neutral" },
                //     { value: 4, text: "Agree" },
                //     { value: 5, text: "Strongly agree" }
                // ]
                // convert questions to SurveyJS format
                const surveyJSON = {
                    title: data.title,
                    pages: [
                        {
                            name: "page1",
                            elements: data.questions.map((q: any) => ({
                                type: "rating",
                                name: q.id.toString(),
                                title: q.text,
                                minRateDescription: "Strongly disagree",
                                maxRateDescription: "Strongly agree",
                                rateMin: 1,
                                rateMax: 5,
                                isRequired: true,
                            })),
                        },
                    ],
                };
                setSurvey(surveyJSON);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        };
        fetchSurvey();

    }, [id]);

    if (loading) return <p>Loading survey...</p>;
    if (notActive) return <p style={{justifySelf:"center", paddingTop:"6rem", fontSize:"32px"}}>This survey is no longer available.</p>;
    if (!survey) return <p  style={{justifySelf:"center", paddingTop:"6rem", fontSize:"32px"}}>Survey not found.</p>;

    return <SurveyForm surveyId={Number(id)} surveyJSON={survey} />;
};

export default SurveyPage;